export const colors = {
  brand: '#007ec1',
  brandGreen: '#95bc1a',
}
